export const restrictInput = function(el, key, arg) {
  el.addEventListener('keypress', function(event) {
    if (arg.data.attrs.maxLength == event.target.value.length) {
      event.preventDefault();
    }
  });
};
